
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', delay = 0, className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; delay?: number; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation, delay)} ${className}`}>
      {children}
    </div>
  );
}

export default function Values() {
  const values = [
    { icon: 'ri-shield-star-line', title: 'Seguridad Primero', desc: 'Los datos de los pacientes son sagrados. Cada decisión de diseño prioriza la seguridad y privacidad.' },
    { icon: 'ri-user-heart-line', title: 'Centrados en el Usuario', desc: 'Diseñamos con y para oftalmólogos. Cada funcionalidad nace de necesidades clínicas reales.' },
    { icon: 'ri-rocket-line', title: 'Innovación Continua', desc: 'Actualizaciones mensuales basadas en feedback real. Nunca dejamos de mejorar la plataforma.' },
    { icon: 'ri-hand-heart-line', title: 'Impacto Social', desc: 'Creemos que la tecnología debe democratizar el acceso a una mejor atención oftalmológica.' },
    { icon: 'ri-team-line', title: 'Colaboración', desc: 'Trabajamos codo a codo con nuestros clientes. Su éxito es nuestro éxito.' },
    { icon: 'ri-sparkling-line', title: 'Excelencia', desc: 'No nos conformamos con lo bueno. Buscamos la excelencia en cada línea de producto y servicio.' },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fade-in">
          <div className="text-center mb-16">
            <span className="inline-block text-xs font-semibold text-emerald-600 uppercase tracking-widest mb-3">Nuestros Valores</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Los principios que nos <span className="font-display italic text-emerald-600">guían</span>
            </h2>
          </div>
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((value, index) => (
            <AnimatedSection key={index} animation="slide-up" delay={index * 80}>
              <div className="group p-7 rounded-xl border border-gray-100 hover:border-emerald-200 hover:shadow-lg transition-all cursor-pointer bg-white h-full">
                <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mb-5 group-hover:bg-emerald-100 group-hover:scale-110 transition-all">
                  <i className={`${value.icon} text-emerald-600 text-xl`}></i>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{value.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{value.desc}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
